module.exports = __webpack_public_path__ + "img/cloth_g1_item_08.0d2d610a.svg";